import { ReactNode } from 'react';
import ConfigProvider from '../providers/config-provider';
import GQLProvider from '../providers/graphql-provider';
import LoaderProvider from '../providers/loader-provider';
import Loader from '../components/basic/loader';
import { HelmetProvider } from 'react-helmet-async';

export default function RootWrapper({ children }: { children: ReactNode }): JSX.Element {
  const helmetContext = {};
  return (
    <HelmetProvider context={helmetContext}>
      <LoaderProvider>
        <Loader>
          <ConfigProvider>
            <GQLProvider>{children}</GQLProvider>
          </ConfigProvider>
        </Loader>
      </LoaderProvider>
    </HelmetProvider>
  );
}
